<template>
  <div>
    <el-form
      :inline="true"
      :model="form"
      v-bind="$attrs"
      ref="form"
      class="common-form"
      size="small"
    >
      <el-form-item
        v-for="(item, i) in searchItems"
        v-bind="item"
        :key="i"
        :prop="item.value"
      >
        <template v-if="item.type === 'select'">
          <el-select
            clearable
            v-model="form[item.value]"
            @change="handleSelect($event, item.value)"
            @clear="clear"
          >
            <el-option
              v-for="(item, index) in item.options"
              :key="index"
              v-bind="item"
            >
            </el-option>
          </el-select>
        </template>
        <template v-else-if="item.type === 'dictSelect'">
          <DictSelect
            @search="submit"
            :value.sync="form[item.value]"
            :typeCode="item.code"
          />
        </template>
        <template v-else-if="item.type === 'cascader'">
          <el-cascader
            v-model="form[item.value]"
            :props="{ emitPath: false }"
            :options="item.options"
            clearable
            @change="handleSelect($event, item.value)"
          />
        </template>
        <template v-else>
          <el-input
            v-model="form[item.value]"
            v-bind="item"
            placeholder="请输入..."
            clearable
            @clear="clear"
          ></el-input>
        </template>
      </el-form-item>
      <el-form-item class="btn">
        <el-button type="primary" icon="el-icon-search" @click="submit">
          查询
        </el-button>
        <!-- <el-button @click="resetForm">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import DictSelect from "@/components/DictSelect";
import { isNumber, isEmpty } from "lodash";

export default {
  props: {
    searchItems: [],
    form: {},
  },
  components: {
    DictSelect,
  },
  data() {
    return {};
  },
  mounted() {
    // console.log(this.searchItems);
  },
  methods: {
    /**
     * 过滤表单对象,空数组也过滤，只取已定义的
     * @param values 要过滤的对象
     */
    filterObject(values) {
      const r = {};
      Object.keys(values).forEach((k) => {
        // 数字不过滤
        if (isNumber(values[k]) || !isEmpty(values[k])) {
          r[k] = values[k];
        }
      });
      return r;
    },
    submit() {
      this.$emit("search", { ...this.filterObject(this.form) });
    },
    clear() {
      // console.log("clear");
      this.$emit("clear", { ...this.filterObject(this.form) });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.$emit("search", {});
    },
    handleSelect(value, type) {
      // console.log('handleSelect', type, value);

      const typeIndex = ["taskType", "typeParentId"]
      // console.log('typeIndex', typeIndex.includes(type));
      // 获取二级分类
      if(typeIndex.includes(type)) {
        // 每次选中后，请空二级选项
        delete this.form.sportId;
        delete this.form.typeId;
        this.$emit("taskTypeChange", value);
      }
      
      // 反馈类型
      if(type == "typeId" && !value) {
        // delete this.form.status;
        this.clear()
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
